import React from 'react';
import ReactDOM from 'react-dom/client';
import "./reset.css";
import './index.css';

import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { LayoutProvider } from './context/layoutContext';
import { StoreProvider } from './context/storeContext';
import { UserProvider } from './context/userContext';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <UserProvider>
      <StoreProvider>
        <BrowserRouter basename='/b2b'>
          <LayoutProvider>

            <App />
          </LayoutProvider>
        </BrowserRouter>
      </StoreProvider>
    </UserProvider>
  </React.StrictMode>
);
